module.exports = __webpack_public_path__ + "img/charge_bike2.5e5b400a.png";